import { render } from "./AssignTraineeModal.vue?vue&type=template&id=692654bf&scoped=true"
import script from "./AssignTraineeModal.vue?vue&type=script&lang=js"
export * from "./AssignTraineeModal.vue?vue&type=script&lang=js"

import "./AssignTraineeModal.vue?vue&type=style&index=0&id=692654bf&scoped=true&lang=css"
/* custom blocks */
import block0 from "./AssignTraineeModal.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-692654bf"]])

export default __exports__